import React, { useState, useEffect } from "react";

import { useLocation, useOutletContext } from "react-router-dom";
import MonitorPatientStepper from "./MonitorPatientStepper";
import ConsentFormModal from "../ClinicModal/ConsentFormModal";

function MonitorPatientDetails() {
  const [activeStep, setActiveStep] = useState(0);
  const [show, setShow] = useState(false);
    
  const location = useLocation();
    useEffect(() => {
      if (location.state?.showModal) {
        setShow(true);
      }
    }, [location.state]);
  
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const outletContext = useOutletContext();

const setPageTitle = outletContext?.setPageTitle || (() => {});



 useEffect(() => {
        setPageTitle("Add Patient Details");
    }, [])

  return (
    <div>
      <main style={{ width: "100%", height: "100%", padding: "1rem" }}>
        {/* <div className="row">
          <div className="col-12">
            <h3 className="fw-bold h3-tFkjpOnsnt" style={{ color: "#000" }}>
              Add Doctor Details
            </h3>
          </div>
        </div> */}

        <div className="row">

          {/* <ConsentFormModal show={show} setShow={setShow} handleClose={() => setShow(false)}/> */}
          <MonitorPatientStepper  steps={2} activeStep={activeStep} setActiveStep={setActiveStep}/>
        </div>
      </main>
    </div>
  );
}

export default MonitorPatientDetails;
